import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MultiSelectInput from "components/MainApp/atoms/Forms/MultiSelectInputGeneric";
import CostumCheckbox from "components/Auth/atoms/forms/CheckboxCostum";
import ProductAddedList from "components/MainApp/organisms/Orders/RequestOrders/ProductAddedList";
import SearchWithComponentsNoForm from "components/MainApp/atoms/Filters/SearchWithComponentsNoForm";
import { isMobile } from "helpers/Mobile";
import trashIcon from "assets/images/trash-icon.svg";
import styles from "./Step1.module.scss";
import i18n from 'i18n';
import { capitalize } from 'helpers/utils/utils_general';

export class AddEmbalajeStep1 extends React.Component {
  render() {
    const { embalaje, handleChange, handleSelect, handleContinue, enableContinue, error, types, paletType, changePaletType, editMode,
      //product selector props
      resultList,
      searchValue,
      products,
      totalProducts,
      handleSelectToAddProduct,
      handleSelectedProductQuantityChange,
      handleAdd,
      handleAddProduct,
      selectedProducts,
      handleDeleteAddedProduct,
      changePage,
      pagination
    } = this.props;

    const stepContent = (
      <form onSubmit={handleContinue}>
        <div className={styles["add-embalaje-wizard-step-one-content"]}>

          <div className={styles["add-embalaje-top"]}>
            <div className={styles["add-embalaje-left"]}>
              <div className={styles["add-embalaje-wizard-step-one-field"]} data-automation-id="input-type">
                <MultiSelectInput
                  items={types}
                  required={true}
                  label={i18n.t("packaging.type")}
                  selected={embalaje.type}
                  multiple={false}
                  handleChange={(e) => handleSelect(e, 'type')}
                  disabled={editMode}
                />
              </div>

              {!isMobile && embalaje?.type?.id === 'PALLET' && <div className={styles["add-embalaje-right"]}>
                {/* {embalaje?.type?.id === 'PALLET' && */}
                  <div className={styles["add-embalaje-palet-options"]}>
                    <CostumCheckbox
                      label={i18n.t("boxes")}
                      checked={paletType === "BOX"}
                      handleChange={!editMode && changePaletType}
                      disabled={true}
                    ></CostumCheckbox>
                    <CostumCheckbox
                      label={i18n.t("units")}
                      checked={paletType === "UNITS"}
                      handleChange={!editMode && changePaletType}
                      disabled={true}
                    ></CostumCheckbox>
                  </div>
                {/* } */}
              </div>}

              {isMobile && <div className={styles["add-embalaje-wizard-step-one-field"]}>
                {embalaje?.type?.id === 'PALLET' &&
                  <div className={styles["add-embalaje-palet-options"]}>
                    <CostumCheckbox
                      label={i18n.t("boxes")}
                      checked={paletType === "BOX"}
                      handleChange={!editMode && changePaletType}
                      disabled={true}
                    ></CostumCheckbox>
                    <CostumCheckbox
                      label={i18n.t("units")}
                      checked={paletType === "UNITS"}
                      handleChange={!editMode && changePaletType}
                      disabled={true}
                    ></CostumCheckbox>
                  </div>
                }
              </div>}

              <div className={styles["add-embalaje-wizard-step-one-field"]} data-automation-id="input-sku">
                <MainInput
                  label={capitalize(i18n.t("code"))}
                  required={true}
                  id={"embalaje-sku"}
                  name="sku"
                  value={embalaje ? embalaje.sku : ''}
                  handleChange={handleChange}
                  maxLength={100}
                  error={error.sku && error.sku}
                  disabled={editMode}
                />
              </div>
              <div className={styles["add-embalaje-wizard-step-one-field"]} data-automation-id="input-name">
                <MainInput
                  label={capitalize(i18n.t("name"))}
                  required={true}
                  id={"embalaje-name"}
                  name="name"
                  value={embalaje ? embalaje.name : ''}
                  handleChange={handleChange}
                  maxLength={100}
                  error={error.name && error.name}
                />
              </div>
            </div>
            {/* {!isMobile && <div className={styles["add-embalaje-right"]}>
              {embalaje?.type?.id === 'PALLET' &&
                <div className={styles["add-embalaje-palet-options"]}>
                  <CostumCheckbox
                    label={i18n.t("boxes")}
                    checked={paletType === "BOX"}
                    handleChange={!editMode && changePaletType}
                    disabled={true}
                  ></CostumCheckbox>
                  <CostumCheckbox
                    label={i18n.t("units")}
                    checked={paletType === "UNITS"}
                    handleChange={!editMode && changePaletType}
                    disabled={true}
                  ></CostumCheckbox>
                </div>
              }
            </div>} */}
          </div>
          <div className={styles["add-embalaje-bottom"]}>
            <div className={styles["add-embalaje-wizard-step-one-field"]} data-automation-id="input-search">
              <div className={styles["add-embalaje-wizard-step-one-search-wrapper"]}>
                <SearchWithComponentsNoForm
                  placeholder={i18n.t("search.by.name.or.code")}
                  resultList={resultList}
                  value={searchValue}
                  onlyStockHidden={true}
                  handleChange={handleChange}
                  handleSelectToAddProduct={handleSelectToAddProduct} handleSelectedProductQuantityChange={handleSelectedProductQuantityChange} handleAdd={handleAdd}
                  selectedProducts={selectedProducts}
                  isMobile={isMobile}
                />
              </div>

              {products.length > 0 && <div className={styles["products-list-wrapper"]}><ProductAddedList total={totalProducts} products={products} edit={true} handleEdit={handleAddProduct} handleDelete={handleDeleteAddedProduct}
                changePage={changePage}
                trashIcon={<img src={trashIcon} alt="delete" />}
                pagination={pagination}
              ></ProductAddedList></div>}
            </div>

          </div>
          <div className={styles["add-embalaje-wizard-step-one-action-wrapper"]}>
            <button type="button" className={`${styles["add-embalaje-wizard-step-one-action-button"]} ${!enableContinue && styles["disabled"]}`} onClick={enableContinue ? handleContinue : undefined} >
              {i18n.t("continue").toUpperCase()}
            </button>
          </div>
        </div>
      </form>
    );

    return (
      <div className={styles["add-embalaje-wizard-step-one-container"]}>
        <Step title={i18n.t("packaging.main.step.title")} content={stepContent}></Step>
      </div>
    );
  }
}

export default AddEmbalajeStep1;
